import React from 'react'
import { TabProps } from '@material-ui/core'
import Tab from '@material-ui/core/Tab'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'
import { primaryBlue, secondaryText } from '../../../styles/material-ui-theme-v2'

const YumLeaderboardTabCompact = withStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '16px',
      paddingRight: '16px',
      minHeight: '17px',
      minWidth: 'auto',
      textTransform: 'none',
      //borderRadius: '8px',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '17px',
      whiteSpace: 'nowrap',
      color: '#495881',
    },
    textColorPrimary: {
      color: secondaryText,
      //opacity: 0.4,
    },
    selected: {
      opacity: 1,
      color: primaryBlue,
    },
    wrapper: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  }),
)(({ classes, ...props }: TabProps) => {
  return <Tab classes={classes} {...props} />
})

export default YumLeaderboardTabCompact
